<script>
export default {
  data() {
    return {}
  },
  components: {},
  methods: {
    redirectToAgentLogin() {
      this.$router.push({path: `/login`})
    },
  },
}
</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="agent-signin-grid-content">
        <div class="responsive-container">


          <el-row :gutter="30" style="display: flex; align-items: center">
            <el-col
              :span="24"
              style="display: flex;
    flex-direction: column;
    align-items: flex-start;"
            >
              <el-row>
                <el-col :span="24">
                  <span class="agent-question">Are you an agent?</span>
                  <el-row
                    style="display: flex; justify-content: flex-start; padding-top: 10px"
                  >
                    <el-col :span="24">
                      <span class="account-creation-instruction"
                      >Sign in or create an account here</span
                      >
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 10px">
                    <el-col :span="6">
                      <el-button type="primary" @click=redirectToAgentLogin
                                 class="agent-sign-in-btn">
                        Agent Sign in
                      </el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12" style="display: flex; flex-direction: column; align-items: flex-end">
              <img src="../../assets/unifi-logo-new.svg">
            </el-col>
          </el-row>


          <!--          <div class="responsive-content">-->
          <!--            <div class="sign-in-information">-->
          <!--              <div class="agent-question">Are you an agent?</div>-->
          <!--              <div class="account-creation-instruction">Sign in or create an account here.</div>-->
          <!--            </div>-->
          <!--&lt;!&ndash;            <div class="agent-sign-in-heading">Agent Sign in</div>&ndash;&gt;-->
          <!--            <el-button type="primary" @click=redirectToAgentLogin-->
          <!--                       class="agent-sign-in-btn">-->
          <!--              Agent Sign in-->
          <!--            </el-button>-->
          <!--          </div>-->
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.responsive-container {
  //justify-content: center;
  //align-items: center;
  background-color: #ffffff;
  align-self: stretch;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 20px 60px;
}

.responsive-content {
  display: flex;
  width: 100%;
  max-width: 100%;
  gap: 20px;
}

@media (max-width: 991px) {
  .responsive-container {
    max-width: 100%;
    padding: 0 20px;
    flex-wrap: wrap;
  }

  .sign-in-information {
    max-width: 100%;
  }

  .agent-question {
    max-width: 100%;
  }
}

.sign-in-information {
  display: flex;
  flex-grow: 1;
  flex-basis: 0%;
  flex-direction: column;
}

.agent-question {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 40px DINosaur-a, sans-serif;
}

.account-creation-instruction {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  margin-top: 12px;
  font: 400 16px/125% DINosaur-a, sans-serif;
}

@media (max-width: 991px) {
  .account-creation-instruction {
    max-width: 100%;
  }
}

.agent-sign-in-btn {
  color: #fff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  padding: 20px 60px;
  font: 600 20px DINosaur-a, sans-serif;
  border-radius: 5px;
}

.agent-signin-grid-content {
  display: flex;
  justify-content: center;
}

.agent-question {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 40px DINosaur-a, sans-serif;
}

@media (max-width: 991px) {
  .agent-question {
    max-width: 100%;
  }
}

.account-creation-instruction {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font: 400 16px/125% DINosaur-a, sans-serif;
}


</style>



// WEBPACK FOOTER //
// src/components/package/agentSignIn.vue